export default () => ({
	isActive: false,

	init() {
		console.log("Favorite button component initialized");
	},
	submit(id) {
		
		fetch('/actions/website/exercise/add-to-favorites/', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			},
			body: JSON.stringify({ exerciseId: id, CRAFT_CSRF_TOKEN: window.csrfTokenValue })
		})
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response.json();
		})
		.then(data => {
			console.log('Success: '+data.message || 'Favorite updated successfully', data);
			this.isActive = data.isFavorite
		})
		.catch(error => {
			console.error('Error:', error);
			alert('There was an error updating your favorite. Please try again later.');
		});
	}
});